<template>
    <div class="container" id="TeammateInfo_container" v-title="'添加队友信息'">
        <Navigation-bar :title="scrollTop > titleHeight ? '添加队友信息' : ''" v-scrollShadow="scrollTop" @backPage="backPage()"></Navigation-bar>
         <div class="container_content">
             <div id="TeammateInfo">
                <Scroll
                    :scroll="scrollTop"
                    @scrollChange="scrollTop = $event"
                >
                    <Title title="添加队友信息" :subtitle="subtitle || '填写队友基本信息'"></Title>
                    <div class="TeammateInfo_content">
                        <Fold label="1.姓名" 
                            :text="form.name" 
                            :unfold="unfoldName == 'name'" 
                            :error="errorUnfold == 'name'"
                            :required="true"
                            @unfold-change="unfoldChange(...arguments,'name')"
                        >
                            <Input 
                                v-model.trim="form.name" 
                                :focus="unfoldName == 'name'" 
                                placeholder="请输入姓名"
                                maxlength="20"
                                @input="nameChange"
                                v-if="isNew"></Input>
                            <Input :value="form.name" disabled v-else></Input>
                        </Fold>
                        <Fold label="2.手机号" 
                            :text="form.phone" 
                            :unfold="unfoldName == 'phone'" 
                            :error="errorUnfold == 'phone'"
                            :required="true"
                            @unfold-change="unfoldChange(...arguments,'phone')"
                        >
                            <div id="phone_content">
                                <Input 
                                    type="tel" 
                                    pattern="\d*" 
                                    v-model.trim="form.phone" 
                                    :focus="unfoldName == 'phone'" 
                                    placeholder="请输入手机号" 
                                    maxlength="11" 
                                    @input="phoneChange" 
                                    v-if="isNew"></Input>
                                <Input :value="form.phone" disabled v-else></Input>
                                <button class="updatePhone" v-href="phoneUrl" v-if="!isNew && isAllowUpdateInfo && !isRealName && !isEnrollGroup">修改</button>
                            </div>
                            <div class="phoneHint" v-if="verify.state">
                                <p v-if="verify.state == 2">此号码已被系统中其他人员占用请<span @click="verify.state = 3">验证手机号</span></p>
                                <div class="codeBox" v-else-if="verify.state == 3">
                                    <div class="code_input">
                                        <Input type="tel" pattern="\d*" maxlength="6" v-model.trim="verify.code" placeholder="请输入验证码" :class="{'error': verify.error}"></Input>
                                        <span v-show="(verify.isFirst || verify.code.length != 6) && this.countDown == 60" class="text-btn" @click="sendCode()">{{!verify.isFirst ? '重新发送' : '获取验证码'}}</span>
                                        <span v-show="verify.code.length != 6 && this.countDown < 60" class="text-btn" style="color: #1B1C1E;" v-text="countDownText"></span>
                                        <button v-show="verify.code.length == 6 && !verify.isFirst" @click="verifyCode()">验证</button>
                                    </div>
                                </div>
                            </div>
                        </Fold>
                        <template v-if="!isNew || verify.isSuccess">
                        <Fold label="3.证件类型" 
                            :text="cardInfo.name" 
                            :unfold="unfoldName == 'identityType'" 
                            :error="errorUnfold == 'identityType'"
                            :required="!!fieldsOptions.identity_limit"
                            @unfold-change="unfoldChange(...arguments,'identityType')"
                        >
                            <div>
                                <Option v-for="(item,index) in identityTypeList" :key="index"
                                    :active="form.identityType == item.type"
                                    :disabled="!isAllowUpdateInfo || isRealName || isEnrollGroup"
                                    @click="selectIdentityType(item.type)">{{item.name}}</Option>
                            </div>
                        </Fold>
                        <Fold label="4.证件号" 
                            :text="form.identityNo" 
                            :unfold="unfoldName == 'identityNo'" 
                            :error="errorUnfold == 'identityNo'"
                            :required="!!fieldsOptions.identity_limit"
                            @unfold-change="unfoldChange(...arguments,'identityNo')"
                        >
                            <Input 
                                v-model.trim="form.identityNo" 
                                :disabled="isRealName || isEnrollGroup"
                                :focus="unfoldName =='identityNo'" 
                                placeholder="请输入证件号" 
                                :maxlength="cardInfo.len || 18" 
                                @input="identityNoChange" 
                                v-if="isAllowUpdateInfo"></Input>
                            <Input :value="form.identityNo" disabled v-else></Input>
                        </Fold>
                        <Fold label="5.性别" 
                            :text="['男','女'][form.sex - 1]" 
                            :unfold="unfoldName == 'sex'" 
                            :error="errorUnfold == 'sex'"
                            :required="!!fieldsOptions.sex_limit"
                            @unfold-change="unfoldChange(...arguments,'sex')"
                        >
                            <template v-if="form.identityType == 1 && (!!fieldsOptions.identity_limit || !!form.identityNo)|| !isAllowUpdateInfo || isRealName || isEnrollGroup">
                                <Option :active="form.sex == 1" disabled key="a1">男</Option>
                                <Option :active="form.sex == 2" disabled key="a2">女</Option>
                            </template>
                            <template v-else>
                                <Option :active="form.sex == 1" @click="sexChange(1)" key="b1">男</Option>
                                <Option :active="form.sex == 2" @click="sexChange(2)" key="b2">女</Option>
                            </template>
                        </Fold>
                        <Fold label="6.出生日期" 
                            :text="form.birthDate" 
                            :unfold="unfoldName == 'birthDate'" 
                            :error="errorUnfold == 'birthDate'"
                            :required="!!fieldsOptions.birthday_limit"
                            @unfold-change="unfoldChange(...arguments,'birthDate')"
                        >
                            <template v-if="form.identityType == 1 && (!!fieldsOptions.identity_limit || !!form.identityNo) || !isAllowUpdateInfo || isRealName || isEnrollGroup">
                                <Option disabled key="1">{{form.birthDate || "选择日期"}}</Option>
                            </template>
                            <template v-else>
                                <Option @click="setDate()" key="2">{{form.birthDate || "选择日期"}}</Option>
                            </template>
                        </Fold>
                        <template v-if="ExtraDataDefines.length">
                            <template v-for="(item,index) in ExtraDataList">
                                <Fold :key="item.Field" :label="`${6 + (index + 1)}.${item.Name}`" 
                                    :text="extraForm[item.Field]" 
                                    :unfold="unfoldName == item.Field" 
                                    :error="errorUnfold == item.Field" 
                                    :required="item.Mandatory"
                                    @unfold-change="unfoldChange(...arguments,item.Field)" 
                                >
                                    <template v-if="item.DataType == 'Text'">
                                        <Input :type="item.Precision ? 'textarea' : ''"
                                            :focus="unfoldName === item.Field" 
                                            v-model.trim="extraForm[item.Field]" 
                                            :placeholder="item.InputTips || `请输入${item.Name}`" 
                                            :maxlength="item.Max"
                                            :disabled="!isAllowUpdateInfo || isEnrollGroup"
                                            @input="textInput"></Input>
                                    </template>
                                    <template v-else-if="item.DataType == 'Integer'">
                                        <Input type="number"
                                            integer
                                            :focus="unfoldName === item.Field" 
                                            v-model.number="extraForm[item.Field]"
                                            :placeholder="item.InputTips || `请输入${item.Name}`" 
                                            :disabled="!isAllowUpdateInfo || isEnrollGroup"
                                            @input="textInput"></Input>
                                    </template>
                                    <template  v-else-if="item.DataType == 'Number'">
                                        <Input type="number"
                                            :focus="unfoldName === item.Field" 
                                            v-model.number="extraForm[item.Field]"
                                            :placeholder="item.InputTips || `请输入${item.Name}`" 
                                            :disabled="!isAllowUpdateInfo || isEnrollGroup"
                                            @input="textInput"></Input>
                                    </template>
                                    <template v-else-if="item.DataType == 'Enum'">
                                        <div class="extra_select">
                                            <Option 
                                                :lineNumber="2"
                                                v-for="(option, optionIndex) in item.Values" 
                                                :key="optionIndex"
                                                :active="extraForm[item.Field] == option"
                                                :disabled="!isAllowUpdateInfo || isEnrollGroup"
                                                @click="selectClick(item.Field, option)"
                                            >{{option}}</Option>
                                        </div>
                                    </template>
                                    <template v-else-if="['DateTime', 'Date'].includes(item.DataType)">
                                        <Input type="text"
                                            :value="extraForm[item.Field]"
                                            :placeholder="item.InputTips || `请选择${item.Name}`" 
                                            :disabled="!isAllowUpdateInfo || isEnrollGroup"
                                            readonly="readonly" @click="selectDateTime(item)"></Input>
                                    </template>
                                </Fold>
                            </template>
                        </template>
                        <div class="upload_images_title">
                            <div class="title">请上传{{cardInfo.name}}</div>
                            <div class="desc">{{cardInfo.text}}（非必填）</div>
                        </div>
                        <div class="upload_images identity_card">
                            <div class="image_item front" @click="uploadImg(1)">
                                <img src="@images/身份证_正面@2x.png" v-show="!form.frontImg" class="default">
                                <img :src="form.frontImg" v-show="form.frontImg" class="image">
                            </div>
                            <div class="image_item behind" @click="uploadImg(2)">
                                <img src="@images/身份证_反面@2x.png" v-show="!form.behindImg" class="default">
                                <img :src="form.behindImg" v-show="form.behindImg" class="image">
                            </div>
                        </div>
                        <div class="upload_images_title">
                            <div class="title">请上传免冠大头照</div>
                            <div class="desc">
                            <template v-if="fieldsOptions.portrait_photo">用于制作比赛秩序册（必填）</template>
                            <template v-else>（非必填）</template>
                            </div>
                        </div>
                        <div class="upload_images">
                            <div class="image_item portrait" @click="showUploadPortraitPhoto()">
                                <img src="@images/肖像@2x.png" v-show="!form.portraitImg" class="default">
                                <img :src="form.portraitImg" v-show="form.portraitImg" class="image">
                            </div>
                        </div>
                        <button id="submit" @click="submit()">完成</button>
                        </template>
                    </div>
                </Scroll>
             </div>
         </div>
        <Datetime-picker ref="datePicker" v-bind="datePickerConfig" @change="datePickerChange"></Datetime-picker>
        <UploadPortraitPhoto ref="uploadPortraitPhoto" :ossConfig="UploadOptions"></UploadPortraitPhoto>
    </div>
</template>
<script>
import Fold from '../components/Fold.vue';
import Input from '../components/Input.vue';
import Option from '../components/Option.vue';
import DatetimePicker from '@/components/datetime-picker/main.vue';
import UploadPortraitPhoto from '@/components/UploadPortraitPhoto.vue';

import { 
    convertSize,
    dateFormat,
    identityCard,
    BV
} from '@js';
import {
    updatePortrait,
    backPage
} from '@js/appInteraction';
import {
    GetLeagueEnrollFieldsOptions,
    GetUserRegisInfo,
    SendVerificationCode,
    CheckVerificationCode,
    GetIndividualEnrollUploadOption,
    IndividualEnrollMateToDoubleCheckUserInfo,
    SaveIndividualEnrollDoubleMate,
    GetMyIndividualEnrollMateInfo,
    AlterMyIndividualEnrollMateInfo,
    CheckIndividualEnrollChangedGroupsAfterBaseInfoChanged,
    CheckIndividualEnrollChangedGroupsAfterAddMate,
    GetUserInfoForIndividualEnrollAddMate
} from '@/api';
const MOBILE = /^1(3|4|5|6|7|8|9)\d{9}$/;
import extra from '@/mixins/extra';
import formValidator from '@/common/formValidator';
export default {
    name:"TeammateInfo",
    components:{
        Fold,
        Input,
        Option,
        DatetimePicker,
        UploadPortraitPhoto
    },
    mixins: [extra],
    data(){
        return {
            subLeagueId: 0,
            groupId: 0,
            userId: 0,
            isNew: false,
            isAllowUpdateInfo: true,
            scrollTop:0,
            unfoldName: '',
            errorUnfold: '',
            isDataUpdate: false,
            userEnrollId: 0,
            isRealName: false,
            form:{
                name:"",
                phone:"",
                identityType: 1,
                identityNo:"",
                sex:0,
                birthDate:"",
                frontImg:"",
                behindImg:"",
                portraitImg:""
            },
			fieldsOptions: {},
            enrollOptions: {},
            verify:{
                isSuccess: false,
                state: 0,
                code: "",
                error:false,
                isFirst:true
            },
            VerificationSerialNumber:"",
            countDown: 60,
            timer: null,
            matchDateShow:false,
            UploadOptions:{},
            datePickerConfig: {},
            isEnrollGroup: false
        }
    },
    created(){
        this.subLeagueId = +this.$route.query.subLeagueId || 0;
        this.groupId = +this.$route.query.groupId || 0;
        this.userId = +this.$route.query.userId || 0;
		this.isNew = this.userId == 0;
        if(!this.isNew){
            GetMyIndividualEnrollMateInfo({
                LeagueId: this.subLeagueId,
                MateUserId: this.userId
            }).then(data=>{
                if(data.Code == 0){
                    this.isAllowUpdateInfo = data.IsAllowAlter;
					this.isEnrollGroup = data.IsMateHaveEnrollGroupByHimselfOrOther;
                    this.init(data.MateUser);
                }else{
                    this.$Prompt({
                        title: '温馨提示',
                        message: data.Message,
                        confirmText: '知道了'
                    }).then(confirm=>{
                        if(confirm){
                            this.$navigation.back();
                        }
                    })
                }
            })
        }
        GetLeagueEnrollFieldsOptions({
            SubLeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                this.fieldsOptions = data.FieldsOptions;
                this.initExtraForm(data.ExtraDataDefines);
				this.enrollOptions = data.EnrollOptions;
            }
        })
        GetIndividualEnrollUploadOption().then(data=>{
            if(data.Code == 0){
                this.UploadOptions = data.Options;
            }
        })
        backPage(()=>{
            this.backPage();
        })
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    computed:{
        titleHeight(){
            return convertSize(1.08);
        },
		subtitle(){
			if(!this.isAllowUpdateInfo){
				return '此组别为队友代报名，如需修改报名信息请联系本人';
			}else if(this.isEnrollGroup){
				return '该队友已报名其他组别，如需修改报名信息请联系本人';
			}else if(this.isRealName){
                return '该队友已实名认证，报名信息中的个人信息不可修改';
            }
			return null;
		},
		phoneUrl(){
			return `/Enroll/MemberUpdatePhone?phone=${this.form.phone}&id=${this.userId}`;
		},
        identityTypeList(){
            return [
                {
                    name: '身份证（港澳台居住证）',
                    text:"二代身份证（港澳台居住证）正反面照片",
                    type: 1,
                    len: 18
                },
                // {
                //     name:'护照',
                //     text:"个人信息页",
                //     type:2,
                //     len: 9,
                //     RegEx:/^[a-zA-Z0-9]{9}$/
                // },
                // {
                //     name:'台湾居民来往大陆通行证',
                //     text:"个人信息页",
                //     type:4,
                //     len: 8,
                //     RegEx:/^\d{8}$/
                // },
                // {
                //     name:'港澳居民来往内地通行证',
                //     text:"个人信息页",
                //     type:5,
                //     len: 9,
                //     RegEx:/^(H|M)\d{8}$/
                // }
            ]
        },
        cardInfo(){
            return this.identityTypeList.find(item=>item.type == this.form.identityType) || {};
        },
        countDownText(){
            return this.countDown ? this.countDown + "s" : "";
        },
        rules(){
			return {
				name: (value, callback)=>{
					if(!value){
						callback('请输入姓名');
					}else if(value.length < 2){
						callback('姓名最少两个字符');
					}
					callback();
				},
				phone: (value, callback)=>{
					if(!value){
						callback('请输入手机号');
					}else if(!value.match(MOBILE)){
						callback('手机号格式有误');
					}
					callback();
				},
				identityType: (value, callback)=>{
					if(!value && this.fieldsOptions.identity_limit){
						callback('请选择证件类型');
					}
					callback();
				},
				identityNo: (value, callback)=>{
					if(!value){
						if(this.fieldsOptions.identity_limit){
							callback('请输入证件号');
						}
					}else if(this.form.identityType == 1){
						let info = identityCard(value);
						if(!info){
							callback('证件号格式有误');
						}else{
							let y = new Date(info.dateBirth).getFullYear();
							if(y < 1900 || y > new Date().getFullYear()){
								callback(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
							}
						}
					}else if(this.form.identityType != 1 && (value.length != this.cardInfo.len || !value.match(this.cardInfo.RegEx))){
						callback('证件号格式有误');
					}
					callback();
				},
				sex: (value, callback)=>{
					if(!value && this.fieldsOptions.sex_limit){
						callback('请选择性别');
					}
					callback();
				},
				birthDate: (value, callback)=>{
					if(!value && this.fieldsOptions.birthday_limit){
						callback('请选择出生日期');
					}
					callback();
				},
				portraitImg: (value, callback)=>{
					if(!value && this.fieldsOptions.portrait_photo){
						callback('请上传照片');
					}
					callback();
				}
			}
		}
    },
    watch:{
        '$store.state.monitor.ENROLL_UPDATE_PHONE':{
            deep: true,
            handler(newVal){
                this.form.phone = newVal.value;
            }
        }
    },
    methods:{
        backPage(){
            if(!this.isDataUpdate){
                this.$navigation.back();
                return;
            }
            this.dataVerify().then(()=>{
                this.$Prompt({
                    title: '温馨提示',
                    message: '您的信息已填写完成，返回将不保留当前填写',
                    showCancel: true,
                    cancelText: '继续返回',
                    confirmText: '提交',
                    showClose: true
                }).then(confirm=>{
                    if(confirm){
                        this.submit();
                    }else{
                        this.$navigation.back();
                    }
                })
            }).catch(()=>{
                this.$Prompt({
                    title: '温馨提示',
                    message: '返回将不保留当前填写，请确认操作',
                    showCancel: true,
                    cancelText: '确认',
                    confirmText: '取消',
                    showClose: true
                }).then(confirm=>{
                    if(!confirm){
                        this.$navigation.back();
                    }
                })
            })
        },
        unfoldChange(e, unfold, unfoldName){
            if(!unfold){
                this.unfoldName = '';
            }else{
                this.unfoldName = unfoldName;
                this.$nextTick(function(){
                    if(!BV().ios){
                        var subItemTop = e.offsetTop;
                        this.scrollTop = subItemTop - 10;
                    }
                })
            }
        },
		setDataUpdate(){
			this.isDataUpdate = true;
		},
		//通用 Text
		textInput(){
			this.setDataUpdate();
		},
		//通用 Enum
		selectClick(formKey, value){
			let oldVal = this.extraForm[formKey];
			if(value != oldVal){
				this.extraForm[formKey] = value;
				this.setDataUpdate();
			}
		},
		//通用 Date
		selectDateTime(item){
			let {
				Field,
				Min,
				Max,
                DataType
			} = item;
            let { 
                format,
                datePickerType
            } = this.getDateFormat(DataType);
			let date = dateFormat(this.extraForm[Field] || new Date(), format);
			let config = {
                type: datePickerType,
				value: date,
				min: dateFormat(Min || '1970-1-1 00:00:00', format),
				max: dateFormat(Max || '2099-12-31 23:59:59', format),
				formKey: Field,
                DataType
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
		},
		//通用 Date
		datePickerChange(value){
			let formKey = this.datePickerConfig.formKey;
			if(!formKey) return;
            if(formKey == 'birthDate'){
                this.$set(this.form, 'birthDate', dateFormat(new Date(value),'yyyy-MM-dd'));
				this.setDataUpdate();
            }else{
                let { format } = this.getDateFormat(this.datePickerConfig.DataType);
                value = dateFormat(value, format);
                let oldVal = this.extraForm[formKey];
                if(value != oldVal){
                    this.extraForm[formKey] = value;
                    this.setDataUpdate();
                }
            }
		},
        init(userInfo){
            if(userInfo){
                let {
                    UserEnrollId,
                    Name,
                    Phone
                } = userInfo;
                this.userEnrollId = UserEnrollId;
                let form = {
                    name: Name || "",
                    phone: Phone || ""
                }
                this.$set(this, 'form', form);
                this.initExtraForm(undefined, userInfo.Extras);
				this.$nextTick(function(){
					this.isDataUpdate = false;
				})
				this.getUserRegisInfo(userInfo, 'edit');
            }
        },
        resetVerify(isSuccess = false){
			this.verify = {
				isSuccess,
				state: 0,
				code: "",
				error: false,
				isFirst: true
			}
		},
		resetForm(){
			let form = this.form;
			form.identityType = 1;
			form.identityNo = "";
			form.sex = 0;
			form.birthDate = "";
			form.frontImg = "";
			form.behindImg = "";
			form.portraitImg = "";
            this.isRealName = false;
            this.isEnrollGroup = false;
		},
		nameChange(){
			if(this.verify.state != 0 || this.verify.isSuccess){
				this.resetVerify();
			}
			let form = this.form;
			clearTimeout(this.verifyTimer);
			if(form.name && form.name.length >= 2 && form.phone.match(MOBILE)){
				this.verifyTimer = setTimeout(()=>{
					this.identityCheck();
				}, 200)
			}
			this.setDataUpdate();
		},
		phoneChange(){
			this.nameChange();
		},
        identityCheck(){
            let loading = this.$Toast.loading('正在验证');
			let name = this.form.name,
				phone = this.form.phone;
            IndividualEnrollMateToDoubleCheckUserInfo({
                LeagueId: this.subLeagueId,
                GroupId: this.groupId,
                MateName: name,
                MatePhone: phone
            }).then(data=>{
                loading.close();
                if(name != this.form.name || phone != this.form.phone) return;

                if(data.Code == 0){
					this.resetForm();
					this.resetVerify(true);
					this.unfoldName = 'identityType';
                    this.userId = 0;
                    this.$Toast('此队友未注册平台');
                }else if(data.Code == 2212){
					this.resetForm();
					this.resetVerify(true);
					this.unfoldName = 'identityType';
                    if(data.EnrollUserInfo){ //3905
                        this.isEnrollGroup = data.IsMateHaveEnrollGroupByHimselfOrOther;
                        this.userId = data.EnrollUserInfo.UserId;
                        this.initExtraForm(undefined, data.EnrollUserInfo.Extras);
                        this.getUserRegisInfo(data.EnrollUserInfo);
                    }else{ //2212
                        this.userId = data.OccupyUserId;
                        if(data.IsPreHaveLogin){
                            this.getUserRegisInfo(undefined, 2212);
                        }else{
                            this.$Toast('此队友未注册平台');
                        }
                    }
                }else if(data.Code == 2214){
                    this.verify.state = 2;
                    this.unfoldName = 'phone';
                    this.userId = data.OccupyUserId;
                }else if(data.Code == 3929){
					this.$Prompt({
						title: '温馨提示',
						message: data.Message,
						confirmText: '知道了',
						confirmColor: '#3A3F49'
					}).then(confirm=>{
						if(confirm){
                            this.$navigation.back();
						}
					})
				}else if(data.Code == 3931){
					let {
						athlete_enroll_single_or_doublegroup_num_max
					} = this.enrollOptions;
                    this.$Prompt({
                        title: '温馨提示',
                        message: `${name}最多只能同时报名${athlete_enroll_single_or_doublegroup_num_max}个组别`,
                        confirmText: '知道了',
                        confirmColor: '#3A3F49'
                    })
                }
            }).catch(()=>{
                loading.close();
            })
        },
        /**
         * 设置信息到页面
         */
        setUserInfo(userInfo){
            if(!userInfo) return;
            let form = this.form;
            form.phone = userInfo.Phone;
            form.identityType = userInfo.IdentityType || 1;
            form.identityNo = userInfo.IdentityNo || "";
            form.frontImg = userInfo.IdentityPhoto1 || "";
            form.behindImg = userInfo.IdentityPhoto2 || "";
            form.portraitImg = userInfo.PortraitPhoto || "";
            if(userInfo.IdentityType == 1 && userInfo.IdentityNo){
                let info = identityCard(userInfo.IdentityNo);
                if(info){
                    form.sex = info.sex;
                    form.birthDate = dateFormat(new Date(info.dateBirth),'yyyy-MM-dd');
                }
            }else{
                form.sex = userInfo.Gender || 0;
                form.birthDate = userInfo.Birthday ? dateFormat(new Date(userInfo.Birthday),'yyyy-MM-dd') : "";
            }
            
			this.$set(this, 'form', {...form});
        },
        /**
         * 获取用户注册信息
         */
        getUserRegisInfo(userInfo, code){
			if(!userInfo){
                var loading = this.$Toast.loading('读取中');
            }
			GetUserRegisInfo({
				QueryUserId: this.userId
			}).then(data => {
				if(!userInfo) loading.close();
				if(data.Code == 0){
					let regisInfo = data.RegisInfo;
			        this.isRealName = regisInfo.HasIdentitySuccess;
					if(userInfo){
						if(this.isRealName){
							let {
								IdentityPhoto1,
								IdentityPhoto2,
								PortraitPhoto
							} = userInfo;
							this.setUserInfo({
								...regisInfo,
								IdentityPhoto1,
								IdentityPhoto2,
								PortraitPhoto
							});
						}else{
							userInfo.Phone = regisInfo.Phone; //手机号可能已经更新
							this.setUserInfo(userInfo);
						}
						this.$nextTick(function(){
							this.isDataUpdate = false;
						})
						let subtitle = this.subtitle;
						if (subtitle) {
							operate.toast({title: subtitle});
						} //三种情况统一在这里处理。包括 修改队友报名信息（edit）、3905 错误码。
					}else{
						if(code == 2212){
							this.$Toast(this.isRealName ? '此队友已实名认证，但尚未填写报名信息' : '此队友已注册平台，但尚未填写报名信息');
						}
						this.setUserInfo(regisInfo);
					}
				}
			}).catch(()=>{
                loading.close();
            })
        },
		/**
		*获取用户信息
		*/
		getUserInfo(userId){
            var loading = this.$Toast.loading('信息获取中');
			GetUserInfoForIndividualEnrollAddMate({
				LeagueId: this.subLeagueId,
				EnrollUserId: userId
			}).then(data=>{
                loading.close();
				if(data.Code == 0){
                    this.userId = 0;
                    this.$Toast('此队友未注册平台');
                }else if(data.Code == 2212){
                    this.userId = data.OccupyUserId;
                    if(data.IsPreHaveLogin){
                        this.getUserRegisInfo(undefined, 2212);
                    }else{
                        this.$Toast('此队友未注册平台');
                    }
                }else if(data.Code == 3905){
                    this.isEnrollGroup = data.IsMateHaveEnrollGroupByHimselfOrOther;
                    this.userId = data.EnrollUserInfo.UserId;
                    this.initExtraForm(undefined, data.EnrollUserInfo.Extras);
                    this.getUserRegisInfo(data.EnrollUserInfo);
                }
			}).catch(()=>{
                loading.close();
            })
		},
        sendCode(){
            let verify = this.verify;
            verify.error = false;
            verify.isFirst = false;
            let loading = this.$Toast.loading('正在发送');
            SendVerificationCode({
                MobileNumber: this.form.phone,
                Purpose: 8
            }).then(data=>{
                loading.close();
                if(data.Code == 0){
                    this.VerificationSerialNumber = data.VerificationSerialNumber;
                    clearInterval(this.timer);
                    this.countDown--;
                    this.timer = setInterval(() => {
                        this.countDown--;
                        if(this.countDown <= 0){
                            this.countDown = 60;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                }
            }).catch(()=>{
                loading.close();
            })
        },
        verifyCode(){
            if(!this.verify.code){
                this.$Toast.error('请输入验证码');
                this.verify.error = true;
                return;
            }
            let loading = this.$Toast.loading('正在验证');
            CheckVerificationCode({
                MobileNumber: this.form.phone,
                VerificationSerialNumber: this.VerificationSerialNumber,
                InputVerificationCode: this.verify.code
            }).then(data=>{
                loading.close();
                if(data.Code == 0){
                    this.resetForm();
					this.resetVerify(true);
					this.unfoldName = 'identityType';
                    this.getUserInfo(data.UserId);
                }else if([2131,2132,2133].includes(data.Code)){
                    this.$Toast.error(data.Message);
                    this.verify.error = true;
                    this.verify.code = "";
                }else{
                    this.verify.error = true;
                }
            }).catch(()=>{
                loading.close();
                this.verify.error = true;
            })
        },
        selectIdentityType(type){
            let identityType = this.form.identityType;
            if(identityType != type){
                this.form.identityType = type;
				this.form.identityNo = '';
                this.unfoldName = 'identityNo';
            }
        },
        identityNoChange(){
			let {
				identityType,
				identityNo
			} = this.form;
			if(identityType == 1 && identityNo.length == 18){
				let info = identityCard(identityNo);
				if (!info) {
                    this.$Toast.error('证件号格式有误');
					this.errorUnfold = 'identityNo';
				}else{
					let y = new Date(info.dateBirth).getFullYear();
					if(y < 1900 || y > new Date().getFullYear()){
                        this.$Toast.error(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
						this.errorUnfold = 'identityNo';
					}else{
						this.form.sex = info.sex;
						this.form.birthDate = dateFormat(new Date(info.dateBirth),'yyyy-MM-dd');
					}
				}
			}else if(identityType == 1 && identityNo.length != 18){
				this.form.sex = 0;
				this.form.birthDate = "";
			}
			this.setDataUpdate();
		},
		sexChange(sex){
			if(this.form.sex != sex){
				this.form.sex = sex;
			    this.setDataUpdate();
			}
		},
        setDate(){//出生日期
			let config = {
                type: 'date',
				value: dateFormat(this.form.birthDate, 'yyyy-MM-dd'),
				min: "1900-01-01",
				max: dateFormat(new Date(),'yyyy-MM-dd'),
				formKey: 'birthDate'
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
        },
        uploadImg(type){
            if(!this.isAllowUpdateInfo || this.isEnrollGroup){
                this.$Toast.warning(this.subtitle);
                return;
            }
            updatePortrait({...this.UploadOptions,Menu:0,Resolutions:'1024,768'}).then(data=>{
                if(type == 1){
                    this.form.frontImg = data.Url;
                }else if(type == 2){
                    this.form.behindImg = data.Url;
                }
				this.setDataUpdate();
            })
        },
		showUploadPortraitPhoto(){
            if(!this.isAllowUpdateInfo || this.isEnrollGroup){
                this.$Toast.warning(this.subtitle);
                return;
            }
			this.$refs.uploadPortraitPhoto.choose().then(ossUrl=>{
				this.form.portraitImg = ossUrl;
				this.setDataUpdate();
			})
		},
        dataVerify(isSubmit){
            let props = Object.keys(this.rules);
			let form = this.form;
			return new Promise((resolve, reject)=>{
				new formValidator(form, props, this.rules).validate((valid, message, prop)=>{
					if(valid){
						let error = this.verifyExtraForm();
						if(error){
							valid = false;
							message = error.text;
							prop = error.id;
						}
					}
					if(isSubmit){
						if(!valid){
                            this.$Toast.error(message);
							this.unfoldName = prop;
							this.errorUnfold = prop;
							return;
						}
						let Extras = this.getExtraForm();
						let params = this.isNew ? {
						    "LeagueId": this.subLeagueId,
						    "GroupId": this.groupId,
						    "MateUser": {
						        "UserId": this.userId,
						        "Name": form.name,
						        "Phone": form.phone,
						        "Gender": form.sex || null,
						        "Birthday": form.birthDate || null,
						        "IdentityType": form.identityType || null,
						        "IdentityNo": form.identityNo || null,
						        "IdentityPhoto1": form.frontImg,
						        "IdentityPhoto2": form.behindImg,
						        "PortraitPhoto": form.portraitImg,
								"Extras": Extras
						    }
						} : {
						    "LeagueId": this.subLeagueId,
						    "MateUserId": this.userId,
						    "GroupId": this.groupId,
							"EnrollBaseInfo": {
								"UserId": this.userId,
								"Name": form.name,
								"Phone": form.phone,
								"Gender": form.sex || null,
								"Birthday": form.birthDate || null,
								"IdentityType": form.identityType || null,
								"IdentityNo": form.identityNo || null,
								"IdentityPhoto1": form.frontImg,
								"IdentityPhoto2": form.behindImg,
								"PortraitPhoto": form.portraitImg
							},
							"Extras": Extras
						};
						resolve(params);
					}else{
						valid ? resolve() : reject();
					}
                })
            })
        },
        submit(){
            if(!this.isAllowUpdateInfo){
                this.$navigation.back();
                return;
            }
            this.dataVerify(true).then(params=>{
                if(this.isNew){
                    CheckIndividualEnrollChangedGroupsAfterAddMate(params).then(data=>{
                        if(data.Code == 0){
						    let groups = data.RemoveMateGroups || [];
                            if(groups.length > 0){
                                this.$Prompt({
                                    title: '报名信息不符合组别限制',
                                    message: `将从【${groups.map(item=>item.Name).join('、')}】中移除队友，是否继续？`,
                                    showCancel: true,
                                    cancelText: '取消',
                                    confirmText: '确认',
                                    showClose: true
                                }).then(confirm=>{
                                    if(confirm){
                                        this.save(params);
                                    }
                                })
                            }else{
                                this.save(params);
                            }
                        }else if(data.Code == 3931){
                            let {
                                athlete_enroll_single_or_doublegroup_num_max
                            } = this.enrollOptions;
                            this.$Prompt({
                                title: '温馨提示',
                                message: `${params.MateUser.Name}最多只能同时报名${athlete_enroll_single_or_doublegroup_num_max}个组别`,
                                confirmText: '知道了',
                                confirmColor: '#3A3F49'
                            })
                        }
                    })
                }else{
                    CheckIndividualEnrollChangedGroupsAfterBaseInfoChanged({
						"LeagueId": params.LeagueId,
						"UserEnrollId": this.userEnrollId,
						"EnrollBaseInfo": params.EnrollBaseInfo,
						"GroupId": params.GroupId
					}).then(data=>{
						if(data.Code == 0){
						    let groups = data.RemoveMateGroups || [];
                            if(groups.length > 0){
                                this.$Prompt({
                                    title: '报名信息不符合组别限制',
                                    message: `将从【${groups.map(item=>item.Name).join('、')}】中移除队友，是否继续？`,
                                    showCancel: true,
                                    cancelText: '取消',
                                    confirmText: '确认',
                                    showClose: true
                                }).then(confirm=>{
                                    if(confirm){
                                        this.alter(params);
                                    }
                                })
                            }else{
                                this.alter(params);
                            }
                        }
                    })
                }
            })
        },
        save(params){
            SaveIndividualEnrollDoubleMate(params).then(data=>{
                if(data.Code == 0){
                    this.$Toast.success('添加成功');
                    this.$store.commit('monitor/ONESELF_ENROLL_TEAMMATE_INFO');
                    setTimeout(()=>{
                        this.$navigation.back();
                    },100)
                }else if(data.Code == 3929){
                    this.$Prompt({
                        title: '温馨提示',
                        message: data.Message,
                        confirmText: '知道了',
                        confirmColor: '#3A3F49'
                    }).then(confirm=>{
                        if(confirm){
                            this.$navigation.back();
                        }
                    })
                }else if(data.Code == 3931){
					let {
						athlete_enroll_single_or_doublegroup_num_max
					} = this.enrollOptions;
                    this.$Prompt({
                        title: '温馨提示',
                        message: `${params.MateUser.Name}最多只能同时报名${athlete_enroll_single_or_doublegroup_num_max}个组别`,
                        confirmText: '知道了',
                        confirmColor: '#3A3F49'
                    })
                }
            })
        },
        alter(params){
            AlterMyIndividualEnrollMateInfo(params).then(data=>{
                if(data.Code == 0){
                    this.$Toast.success('保存成功');
                    this.$store.commit('monitor/ONESELF_ENROLL_TEAMMATE_INFO');
                    setTimeout(()=>{
                        this.$navigation.back();
                    },1000)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
#TeammateInfo{
    position: relative;
    .TeammateInfo_content{
        padding: 0 40px;
        box-sizing: border-box;
    }
    #phone_content{
        position: relative;
        .updatePhone{
            width: 104px;
            height: 56px;
            font-size: 28px;
            color: #FFFFFF;
            font-weight: 500;
            line-height: 56px;
            background: #7AD21A;
            border-radius: 28px;
            position: absolute;
            top: 16px;
            right: 16px;
        }
    }
    .phoneHint{
        margin-top: 16px;
        >p{
            font-size: 28px;
            color: #8B8C8D;
            font-weight: 400;
            line-height: 40px;
            span{
                color: #7AD21A;
                font-weight: 500;
                text-decoration: underline;
                margin-left: 8px;
            }
        }
        .codeBox{
            .code_input{
                position: relative;
                .text-btn{
                    @include line-height(40px);
                    font-size: 28px;
                    color: #7AD21A;
                    font-weight: 500;
                    text-align: right;
                    position: absolute;
                    right: 36px;
                    top: 50%;
                    margin-top: -20px;
                }
                button{
                    display: block;
                    width: 104px;
                    @include line-height(56px);
                    font-size: 28px;
                    color: #FFFFFF;
                    text-align: center;
                    font-weight: 500;
                    background: #7AD21A;
                    border-radius: 8px;
                    position: absolute;
                    right: 36px;
                    top: 50%;
                    margin-top: -28px;
                }
                .input{
                    &.error{
                        background-color: rgba(240,110,67,0.1);
                    }
                }
            }
            .error{
                font-size: 28px;
                color: #F06E43;
                font-weight: 400;
                line-height: 40px;
                margin-top: 16px;
            }
        }
    }
    
    .extra_select > div{
        display: inline-block;
        width: calc((100% - 18px) / 2);
        margin-right: 18px;
        &:nth-of-type(2n){
            margin-right: 0;
        }
    }
    @include uploadImage;
    .upload_images{
        display: flex;
        .front,
        .behind{
            width: 261px;
            height: 196px;
            --center-size: 82px;
            --corner-size: 60px;
            .default{
                --width: 190px;
                --height: 116px;
            }
        }
        .front{
            margin-right: 56px;
        }
        .portrait{
            width: 240px;
            min-height: 240px;
            --center-size: 82px;
            --corner-size: 60px;
            .default{
                --width: 120px;
                --height: 160px;
            }
            
            .image{
                height: auto;
            }
        }
    }
}
#submit{
    @include submit-button;
}
</style>
<style lang="scss">
#TeammateInfo_container{
    .phoneHint{
        .input{
            &.error{
                .input-value{
                    background-color: rgba(240,110,67,0.1);
                }
            }
        }
    }
                
    #date_container{
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 20;
        background: rgba(0,0,0,0.40);
        .date_container_content{
            width: auto;
            height: auto;
            background: #FFFFFF;
            box-shadow: 0px 36px 64px -8px rgba(136,136,136,0.25);
            border-radius: 20px;
            overflow: hidden;
            margin-top: 10%;
        }
        .date_content{
            width: auto;
            height: auto;
            font-size: 28px;
            .layui-laydate{
                width: auto;
                height: auto;
                font-size: 28px;
                color: #1B1C1E;
                font-weight: 400;
                box-shadow: none;
                border: none;
                .layui-laydate-main {
                    width: auto;
                }
            }
            .layui-laydate-header{
                width: 100%;
                height: 100px;
                font-size: 32px;
                color: #7AD21A;
                line-height: 48px;
                font-weight: 700;
                display: flex;
                align-items: center;
                padding: 15px 30px 5px;
                .laydate-set-ym{
                    padding: 0 15px;
                }
                i{
                    position: static;
                    font-size: 32px;
                    padding: 0 15px;
                    color: #7AD21A;
                }
                i:hover,
                span:hover{
                    color: inherit;
                }
            }
            .layui-laydate-content{
                padding: 15px 30px;
                td,th{
                    width: 80px;
                    height: 70px;
                    border-radius: 8px;
                }
                td.layui-this{
                    color: #FFFFFF;
                    font-weight: 700;
                    background: #7AD21A !important;
                }
            }
            .layui-laydate-list{
                padding: 25px 30px;
                li{
                    width: 33%;
                    @include line-height(85px);
                    border-radius: 8px;
                    &.layui-this {
                        background: #7AD21A !important;
                    }
                }
            }
            .laydate-month-list>li{
                @include line-height(90px);
                margin: 0.15rem 0 !important;
            }
        }
        .operation{
            height:90px;
            width: 100%;
            display: flex;
            border-top: 1px #EFEFEF solid;
            button{
                flex: 1;
                @include line-height(90px);
                font-size: 28px;
                color: #3A3F49;
                text-align: center;
                font-weight: 500;
                border-right: 1px #EFEFEF solid;
                &:last-of-type{
                    color: #7AD21A;
                    border-right: none;
                }
            }
        }
    }
}
</style>